import { render, staticRenderFns } from "./ScreenConfigureGroup.vue?vue&type=template&id=12471260&scoped=true"
import script from "./ScreenConfigureGroup.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureGroup.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfigureGroup.vue?vue&type=style&index=0&id=12471260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12471260",
  null
  
)

export default component.exports